export enum LocationTypeEnum {
    COUNTRY='COUNTRY',
    DIVISION = 'DIVISION',
    DISTRICT = 'DISTRICT',
    THANA = 'THANA',
    UNION = 'UNION',
}